import React, { useEffect, useState } from 'react';
import { Col, Input, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { resyncUser } from "../../slices/thunks";
import { createSelector } from 'reselect';
import AuthSlider from 'pages/Authentication/Landing';


const Synchronisation = (props: any) => {
    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            errorMsg: state.Login.errorMsg,
            user: state.Login.user,
        })
    );
    // Inside your component
    const { errorMsg, user } = useSelector(loginpageData);
    const [loader, setLoader] = useState<boolean>(false);

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            username: user.username,
            password: user.password,
            newpassword: "",
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Veuillez saisir votre identifiant"),
            password: Yup.string().required("Veuillez saisir votre mot de passe"),
            newpassword: Yup.string().required("Veuillez saisir votre nouveau mot de passe"),
        }),
        onSubmit: (values) => {
            console.log("INSIDE submit");
            dispatch(resyncUser(values, props.router.navigate));
            setLoader(true)
        }
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                //dispatch(resetLoginFlag());
                setLoader(false)
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "Synchronisation | Business Online";
    return (
        <React.Fragment>
                <div className="auth-content">

                    <Row className="g-0 auth-container">
                         <Col lg={5} xs={12}>
                            <div className="sync-bloc">
                                <div className="mb-4">
                                    <div className="avatar-lg mx-auto">
                                        <div className="avatar-title bg-light text-primary display-5 rounded-circle">
                                            <i className="ri-rotate-lock-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-muted text-center mx-lg-3">
                                    <h2>SYNCHRONISATION</h2>
                                    <p>Vous avez dépassé le nombre de tentatives de génération du mot de passe.<br/>
                                        Merci de saisir un nouveau mot de passe afin de vous connecter.
                                    </p>
                                </div>
                                {errorMsg && <Alert color="danger" transition={{ timeout: 150 }}> {errorMsg} </Alert>}
                                <div className="mt-4">
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        action="#">

                                        <div className="mb-3">
                                            <Input type="text" className="form-control" id="username"
                                                name="username"
                                                placeholder='Identifiant'
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.username || ""}
                                                invalid={
                                                    validation.touched.username && validation.errors.username ? true : false
                                                }
                                            />
                                            {validation.touched.username && validation.errors.username ? (
                                                <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                <Input 
                                                    name="password"
                                                    placeholder='Mot de passe'
                                                    value={validation.values.password || ""}
                                                    type={"password"} 
                                                    className="form-control pe-5 password-input" 
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    invalid={
                                                        validation.touched.password && validation.errors.password ? true : false
                                                    }
                                                />
                                                {validation.touched.password && validation.errors.password ? (
                                                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                <Input 
                                                    name="newpassword"
                                                    placeholder='Nouveau mot de passe'
                                                    value={validation.values.newpassword || ""}
                                                    type={"password"} 
                                                    className="form-control pe-5 password-input" 
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    invalid={
                                                        validation.touched.newpassword && validation.errors.newpassword ? true : false
                                                    }
                                                />
                                                {validation.touched.newpassword && validation.errors.newpassword ? (
                                                    <FormFeedback type="invalid">{validation.errors.newpassword}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <Button color="success" 
                                                disabled={loader && true}
                                                className="w-100" 
                                                type="submit">
                                                {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                SYNCHRONISER
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                         </Col>
                        <AuthSlider />
                    </Row>         
                </div>
                <div className="contact">
                    <Link to="/FAQ">
                        <i className='bx bx-help-circle'></i> <span>F.A.Q</span>
                    </Link>
                </div>
           
        </React.Fragment>
    );
};

export default withRouter(Synchronisation);